import { Link } from "wouter";
import { ReactNode } from "react";
import { Logo } from "@/components/ui/logo/logo";
import { StudyFlowSteps } from "../ui/flow-steps";
import { StudyDropdown } from "@/features/studies/components/study-dropdown";
import { useGetStudy } from "@/api/studio/studies/queries";

/* Prop Types */
interface LayoutProps {
  children: ReactNode;
  projectId: string;
  studyId: string;
  currentStep: string;
}

/*
 * StudiesLayout component
 * This layout wraps the study creation flow in the application
 */
export const StudiesLayout = ({ projectId, studyId, currentStep, children }: LayoutProps) => {
  /* Queries */
  const { data: study, isLoading: isStudyLoading } = useGetStudy(projectId, studyId);

  /* Render */
  return (
    <div className="grow flex flex-col gap-4 px-7 py-4 max-h-screen">
      {/* Header */}
      <header className="min-h-12 flex items-center pl-2">
        <Link href="/" className="flex items-center gap-2">
          <Logo /> <h3 className="font-semibold">Studio</h3>
        </Link>

        {/* Asset steps */}
        <StudyFlowSteps projectId={projectId} studyId={studyId} currentStep={currentStep} />

        {/* Study dropdown */}
        {study && !isStudyLoading && (
          <div className="ml-auto">
            <StudyDropdown projectId={projectId} study={study} />
          </div>
        )}
      </header>
      {/* Content */}
      {children}
    </div>
  );
};
